module.exports = __webpack_public_path__ + "img/external-link-square-alt.006e579c.svg";